// import React, { useEffect, useState } from "react";
// import {
//   Box,
//   Paper,
//   Typography,
//   TextField,
//   MenuItem,
//   Button,
//   CircularProgress,
//   Alert,
//   Snackbar,
// } from "@mui/material";
// import { AddCircleOutlineRounded } from "@mui/icons-material";
// import { keyframes } from "@mui/system";
// import { useNavigate } from "react-router-dom";
// import { adminService } from "../services/adminService";
// import {
//   ROUTES,
//   buttonGradient,
//   buttonGradientHover,
//   buttonShadow,
// } from "../../../constants/consts";
// import Autocomplete from "@mui/material/Autocomplete";

// const fadeInUp = keyframes`
//   from { opacity: 0; transform: translateY(14px); }
//   to   { opacity: 1; transform: translateY(0); }
// `;

// const EMPTY = {
//   title: "",
//   sunucuKodu: "",
//   personel: "",
//   userId: "",
// };

// export default function AdminSupportAdd() {
//   const navigate = useNavigate();
//   const [form, setForm] = useState(EMPTY);
//   const [sunucuKoduList, setSunucuKoduList] = useState([]);
//   const [personelList, setPersonelList] = useState([]);
//   const [usersList, setUsersList] = useState([]);
//   const [loadingOptions, setLoadingOptions] = useState(true);
//   const [loadingUsers, setLoadingUsers] = useState(false);
//   const [saving, setSaving] = useState(false);
//   const [error, setError] = useState("");
//   const [snack, setSnack] = useState({ open: false, msg: "" });

//   /* ─── Başlangıç verileri ─── */
//   useEffect(() => {
//     (async () => {
//       setLoadingOptions(true);
//       try {
//         const [companies, supporters] = await Promise.all([
//           adminService.getCompanies(),
//           adminService.getUsersByType({ type: "destek", sunucuKodu: "" }),
//         ]);
//         setSunucuKoduList(companies.map((c) => c.sunucu_kodu).filter(Boolean));
//         const names = supporters.map((u) => u.username).filter(Boolean);
//         setPersonelList(["Havuz", ...names]);
//       } catch (e) {
//         console.error(e);
//       } finally {
//         setLoadingOptions(false);
//       }
//     })();
//   }, []);

//   /* ─── Sunucu değişince kullanıcıları çek ─── */
//   const loadUsers = async (sunucuKodu) => {
//     if (!sunucuKodu) {
//       setUsersList([]);
//       return;
//     }
//     setLoadingUsers(true);
//     try {
//       const [users, rootUsers] = await Promise.all([
//         adminService.getUsersByType({ type: "user", sunucuKodu }),
//         adminService.getUsersByType({ type: "rootUser", sunucuKodu }),
//       ]);
//       setUsersList([...users, ...rootUsers]);
//     } catch (e) {
//       console.error(e);
//     } finally {
//       setLoadingUsers(false);
//     }
//   };

//   const handleChange = (k) => (e) => {
//     const v = e.target.value;
//     if (k === "sunucuKodu") {
//       setForm((prev) => ({ ...prev, sunucuKodu: v, userId: "" }));
//       loadUsers(v);
//     } else {
//       setForm((prev) => ({ ...prev, [k]: v }));
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (
//       !form.title.trim() ||
//       !form.sunucuKodu ||
//       !form.personel ||
//       !form.userId
//     ) {
//       setError("Tüm alanlar zorunludur.");
//       return;
//     }
//     setSaving(true);
//     setError("");
//     try {
//       await adminService.createSupport({
//         title: form.title.trim(),
//         userId: Number(form.userId),
//         sunucuKodu: form.sunucuKodu,
//         personel: form.personel,
//       });
//       setSnack({ open: true, msg: "Destek talebi oluşturuldu." });
//       setForm(EMPTY);
//       setUsersList([]);
//       setTimeout(() => navigate(ROUTES.ADMIN_SUPPORTS), 900);
//     } catch (err) {
//       console.error(err);
//       setError("Destek talebi oluşturulamadı.");
//     } finally {
//       setSaving(false);
//     }
//   };
//   const normalize = (s = "") => String(s).toLocaleLowerCase("tr-TR").trim();

//   const inputSx = {
//     "& .MuiOutlinedInput-root": {
//       borderRadius: 2,
//       transition: "box-shadow 0.25s ease, background-color 0.25s ease",
//       "&:hover": { backgroundColor: "rgba(4,87,129,0.02)" },
//       "&.Mui-focused": {
//         boxShadow: "0 0 0 4px rgba(4,87,129,0.10)",
//       },
//     },
//   };
//   return (
//     <Box
//       sx={{
//         display: "flex",
//         flexDirection: "column",
//         height: "100%",
//         minHeight: 0,
//         gap: 1.5,
//       }}
//     >
//       {/* Başlık */}
//       <Box
//         sx={{
//           display: "flex",
//           alignItems: "center",
//           gap: 1,
//           flexShrink: 0,
//           animation: `${fadeInUp} 0.4s ease-out both`,
//         }}
//       >
//         <Box
//           sx={{
//             width: 34,
//             height: 34,
//             borderRadius: 2,
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             backgroundColor: "rgba(255,255,255,0.14)",
//             border: "1px solid rgba(255,255,255,0.20)",
//           }}
//         >
//           <AddCircleOutlineRounded sx={{ color: "#fff", fontSize: 20 }} />
//         </Box>
//         <Box>
//           <Typography
//             variant="h6"
//             fontWeight={800}
//             color="#fff"
//             sx={{ fontSize: 18 }}
//           >
//             Yeni Destek Talebi
//           </Typography>
//           <Typography
//             sx={{
//               color: "rgba(255,255,255,0.7)",
//               fontSize: 11.5,
//               fontWeight: 600,
//             }}
//           >
//             Müşteri adına destek talebi oluşturun
//           </Typography>
//         </Box>
//       </Box>

//       {/* Ortalanmış form alanı */}
//       <Box
//         sx={{
//           flex: 1,
//           minHeight: 0,
//           display: "flex",
//           justifyContent: "center",
//           alignItems: "flex-start",
//           overflowY: "auto",
//           pt: 1,
//           pb: 2,
//         }}
//       >
//         <Paper
//           elevation={0}
//           component="form"
//           onSubmit={handleSubmit}
//           sx={{
//             p: { xs: 2.5, sm: 4 },
//             borderRadius: 3,
//             backgroundColor: "rgba(255,255,255,0.98)",
//             boxShadow: "0 12px 32px rgba(0,0,0,0.20)",
//             border: "1px solid rgba(255,255,255,0.30)",
//             width: "100%",
//             maxWidth: { xs: "100%", sm: 900, md: 1100 },
//             animation: `${fadeInUp} 0.5s cubic-bezier(0.22, 1, 0.36, 1) 0.1s backwards`,
//           }}
//         >
//           {error && (
//             <Alert severity="error" sx={{ mb: 3, borderRadius: 2 }}>
//               {error}
//             </Alert>
//           )}

//           <Box
//             sx={{
//               display: "grid",
//               gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
//               gap: { xs: 2, sm: 2.5 },
//             }}
//           >
//             <TextField
//               label="Konu *"
//               value={form.title}
//               onChange={handleChange("title")}
//               fullWidth
//               sx={{ gridColumn: { xs: "1", sm: "1 / span 2" } }}
//             />
//             <TextField
//               label="Sunucu Kodu *"
//               value={form.sunucuKodu}
//               onChange={handleChange("sunucuKodu")}
//               select
//               fullWidth
//               disabled={loadingOptions}
//             >
//               {sunucuKoduList.map((s) => (
//                 <MenuItem key={s} value={s}>
//                   {s}
//                 </MenuItem>
//               ))}
//             </TextField>
//             <TextField
//               label="Destek Personeli *"
//               value={form.personel}
//               onChange={handleChange("personel")}
//               select
//               fullWidth
//               disabled={loadingOptions}
//             >
//               {personelList.map((p) => (
//                 <MenuItem key={p} value={p}>
//                   {p}
//                 </MenuItem>
//               ))}
//             </TextField>
//             <TextField
//               label="Destek İsteyen Kullanıcı *"
//               value={form.userId}
//               onChange={handleChange("userId")}
//               select
//               fullWidth
//               disabled={!form.sunucuKodu || loadingUsers}
//               sx={{ gridColumn: { xs: "1", sm: "1 / span 2" } }}
//               helperText={
//                 loadingUsers
//                   ? "Kullanıcılar yükleniyor…"
//                   : !form.sunucuKodu
//                     ? "Önce sunucu kodu seçin"
//                     : ""
//               }
//             >
//               {usersList.map((u) => (
//                 <MenuItem key={u.id} value={u.id}>
//                   {u.username}
//                 </MenuItem>
//               ))}
//             </TextField>
//           </Box>

//           <Box
//             sx={{
//               mt: 4,
//               display: "flex",
//               gap: 1.5,
//               justifyContent: "flex-end",
//             }}
//           >
//             <Button
//               type="button"
//               variant="outlined"
//               onClick={() => navigate(ROUTES.ADMIN_SUPPORTS)}
//               sx={{
//                 textTransform: "none",
//                 borderRadius: 2,
//                 px: 3,
//                 py: 1.2,
//                 fontWeight: 600,
//               }}
//             >
//               Vazgeç
//             </Button>
//             <Button
//               type="submit"
//               variant="contained"
//               disabled={saving}
//               sx={{
//                 textTransform: "none",
//                 borderRadius: 2,
//                 fontWeight: 700,
//                 px: 4,
//                 py: 1.2,
//                 background: buttonGradient,
//                 boxShadow: buttonShadow,
//                 transition: "transform 0.2s ease, box-shadow 0.2s ease",
//                 "&:hover": {
//                   background: buttonGradientHover,
//                   transform: "translateY(-1px)",
//                 },
//                 "&:active": { transform: "translateY(0) scale(0.98)" },
//                 "&:disabled": { background: "#c7c7c7" },
//               }}
//             >
//               {saving ? (
//                 <CircularProgress size={20} sx={{ color: "#fff" }} />
//               ) : (
//                 "Kaydet"
//               )}
//             </Button>
//           </Box>
//         </Paper>
//       </Box>

//       <Snackbar
//         open={snack.open}
//         autoHideDuration={2500}
//         onClose={() => setSnack({ open: false, msg: "" })}
//         anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
//       >
//         <Alert severity="success" sx={{ borderRadius: 2 }}>
//           {snack.msg}
//         </Alert>
//       </Snackbar>
//     </Box>
//   );
// }
import React, { useEffect, useMemo, useState } from "react";
import {
  Box,
  Paper,
  Typography,
  TextField,
  Button,
  CircularProgress,
  Alert,
  Snackbar,
  Autocomplete,
} from "@mui/material";
import { AddCircleOutlineRounded } from "@mui/icons-material";
import { keyframes } from "@mui/system";
import { useNavigate } from "react-router-dom";
import { adminService } from "../services/adminService";
import {
  ROUTES,
  buttonGradient,
  buttonGradientHover,
  buttonShadow,
} from "../../../constants/consts";

/* ─────────────── Animasyonlar ─────────────── */
const fadeInUp = keyframes`
  from { opacity: 0; transform: translateY(14px); }
  to   { opacity: 1; transform: translateY(0); }
`;

/* ─────────────── Sabitler ─────────────── */
const EMPTY = {
  title: "",
  sunucuKodu: "",
  personel: "",
  userId: "",
};

// Türkçe karakter normalize
const normalize = (s = "") => String(s).toLocaleLowerCase("tr-TR").trim();

// Ortak input stilleri
const inputSx = {
  "& .MuiOutlinedInput-root": {
    borderRadius: 2,
    transition: "box-shadow 0.25s ease, background-color 0.25s ease",
    "&:hover": { backgroundColor: "rgba(4,87,129,0.02)" },
    "&.Mui-focused": {
      boxShadow: "0 0 0 4px rgba(4,87,129,0.10)",
    },
  },
};

// Autocomplete filtre — hem string hem obje destekler
const filterFn = (options, { inputValue }) => {
  const q = normalize(inputValue);
  return options.filter((opt) => {
    if (typeof opt === "string") return normalize(opt).includes(q);
    return normalize(opt?.username || "").includes(q);
  });
};

export default function AdminSupportAdd() {
  const navigate = useNavigate();

  const [form, setForm] = useState(EMPTY);
  const [sunucuKoduList, setSunucuKoduList] = useState([]);
  const [personelList, setPersonelList] = useState([]);
  const [usersList, setUsersList] = useState([]);

  const [loadingOptions, setLoadingOptions] = useState(true);
  const [loadingUsers, setLoadingUsers] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  const [snack, setSnack] = useState({ open: false, msg: "" });

  /* ─────────── Başlangıç verileri ─────────── */
  useEffect(() => {
    (async () => {
      setLoadingOptions(true);
      try {
        const [companies, supporters] = await Promise.all([
          adminService.getCompanies(),
          adminService.getUsersByType({ type: "destek", sunucuKodu: "" }),
        ]);
        setSunucuKoduList(companies.map((c) => c.sunucu_kodu).filter(Boolean));
        const names = supporters.map((u) => u.username).filter(Boolean);
        setPersonelList(["Havuz", ...names]);
      } catch (e) {
        console.error(e);
      } finally {
        setLoadingOptions(false);
      }
    })();
  }, []);

  /* ─────────── Sunucu değişince kullanıcıları çek ─────────── */
  const loadUsers = async (sunucuKodu) => {
    if (!sunucuKodu) {
      setUsersList([]);
      return;
    }
    setLoadingUsers(true);
    try {
      const [users, rootUsers] = await Promise.all([
        adminService.getUsersByType({ type: "user", sunucuKodu }),
        adminService.getUsersByType({ type: "rootUser", sunucuKodu }),
      ]);
      setUsersList([...users, ...rootUsers]);
    } catch (e) {
      console.error(e);
    } finally {
      setLoadingUsers(false);
    }
  };

  /* ─────────── Seçili kullanıcı objesi (Autocomplete için) ─────────── */
  const selectedUser = useMemo(
    () => usersList.find((u) => String(u.id) === String(form.userId)) || null,
    [usersList, form.userId],
  );

  /* ─────────── Sunucu değişimi ─────────── */
  const handleSunucuChange = (v) => {
    setForm((prev) => ({ ...prev, sunucuKodu: v || "", userId: "" }));
    if (v) loadUsers(v);
    else setUsersList([]);
  };

  /* ─────────── Submit ─────────── */
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (
      !form.title.trim() ||
      !form.sunucuKodu ||
      !form.personel ||
      !form.userId
    ) {
      setError("Tüm alanlar zorunludur.");
      return;
    }
    setSaving(true);
    setError("");
    try {
      await adminService.createSupport({
        title: form.title.trim(),
        userId: Number(form.userId),
        sunucuKodu: form.sunucuKodu,
        personel: form.personel,
      });
      setSnack({ open: true, msg: "Destek talebi oluşturuldu." });
      setForm(EMPTY);
      setUsersList([]);
      setTimeout(() => navigate(ROUTES.ADMIN_SUPPORTS), 900);
    } catch (err) {
      console.error(err);
      setError("Destek talebi oluşturulamadı.");
    } finally {
      setSaving(false);
    }
  };

  /* ─────────── Render ─────────── */
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        minHeight: 0,
        gap: 1.5,
      }}
    >
      {/* Başlık */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          flexShrink: 0,
          animation: `${fadeInUp} 0.4s ease-out both`,
        }}
      >
        <Box
          sx={{
            width: 34,
            height: 34,
            borderRadius: 2,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "rgba(255,255,255,0.14)",
            border: "1px solid rgba(255,255,255,0.20)",
          }}
        >
          <AddCircleOutlineRounded sx={{ color: "#fff", fontSize: 20 }} />
        </Box>
        <Box>
          <Typography
            variant="h6"
            fontWeight={800}
            color="#fff"
            sx={{ fontSize: 18 }}
          >
            Yeni Destek Talebi
          </Typography>
          <Typography
            sx={{
              color: "rgba(255,255,255,0.7)",
              fontSize: 11.5,
              fontWeight: 600,
            }}
          >
            Müşteri adına destek talebi oluşturun
          </Typography>
        </Box>
      </Box>

      {/* Ortalanmış form alanı */}
      <Box
        sx={{
          flex: 1,
          minHeight: 0,
          display: "flex",
          justifyContent: "center",
          alignItems: "flex-start",
          overflowY: "auto",
          pt: 1,
          pb: 2,
          "&::-webkit-scrollbar": { width: 6 },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: "rgba(255,255,255,0.20)",
            borderRadius: 3,
          },
        }}
      >
        <Paper
          elevation={0}
          component="form"
          onSubmit={handleSubmit}
          sx={{
            p: { xs: 2.5, sm: 4 },
            borderRadius: 3,
            backgroundColor: "rgba(255,255,255,0.98)",
            boxShadow: "0 12px 32px rgba(0,0,0,0.20)",
            border: "1px solid rgba(255,255,255,0.30)",
            width: "100%",
            maxWidth: { xs: "100%", sm: 900, md: 1100 },
            animation: `${fadeInUp} 0.5s cubic-bezier(0.22, 1, 0.36, 1) 0.1s backwards`,
          }}
        >
          {error && (
            <Alert severity="error" sx={{ mb: 3, borderRadius: 2 }}>
              {error}
            </Alert>
          )}

          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
              gap: { xs: 2, sm: 2.5 },
            }}
          >
            {/* Konu */}
            <TextField
              label="Konu *"
              value={form.title}
              onChange={(e) =>
                setForm((prev) => ({ ...prev, title: e.target.value }))
              }
              fullWidth
              sx={{ ...inputSx, gridColumn: { xs: "1", sm: "1 / span 2" } }}
            />

            {/* Sunucu Kodu — yaz veya seç */}
            <Autocomplete
              size="small"
              options={sunucuKoduList}
              value={form.sunucuKodu || null}
              onChange={(_, v) => handleSunucuChange(v)}
              filterOptions={filterFn}
              noOptionsText="Sunucu bulunamadı"
              disabled={loadingOptions}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Sunucu Kodu *"
                  placeholder="Yaz veya seç"
                  sx={inputSx}
                />
              )}
            />

            {/* Destek Personeli */}
            <Autocomplete
              size="small"
              options={personelList}
              value={form.personel || null}
              onChange={(_, v) =>
                setForm((prev) => ({ ...prev, personel: v || "" }))
              }
              filterOptions={filterFn}
              noOptionsText="Personel bulunamadı"
              disabled={loadingOptions}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Destek Personeli *"
                  placeholder="Yaz veya seç"
                  sx={inputSx}
                />
              )}
            />

            {/* Destek İsteyen Kullanıcı */}
            <Autocomplete
              size="small"
              options={usersList}
              value={selectedUser}
              onChange={(_, v) =>
                setForm((prev) => ({ ...prev, userId: v ? v.id : "" }))
              }
              loading={loadingUsers}
              getOptionLabel={(opt) => opt?.username || ""}
              filterOptions={filterFn}
              isOptionEqualToValue={(a, b) => String(a?.id) === String(b?.id)}
              noOptionsText={
                !form.sunucuKodu
                  ? "Önce sunucu kodu seçin"
                  : loadingUsers
                    ? "Yükleniyor…"
                    : "Kullanıcı bulunamadı"
              }
              disabled={!form.sunucuKodu || loadingUsers}
              sx={{ gridColumn: { xs: "1", sm: "1 / span 2" } }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Destek İsteyen Kullanıcı *"
                  placeholder={
                    !form.sunucuKodu ? "Önce sunucu kodu seçin" : "Yaz veya seç"
                  }
                  sx={inputSx}
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <>
                        {loadingUsers && (
                          <CircularProgress size={16} sx={{ mr: 1 }} />
                        )}
                        {params.InputProps.endAdornment}
                      </>
                    ),
                  }}
                />
              )}
            />
          </Box>

          <Box
            sx={{
              mt: 4,
              display: "flex",
              gap: 1.5,
              justifyContent: "flex-end",
            }}
          >
            <Button
              type="button"
              variant="outlined"
              onClick={() => navigate(ROUTES.ADMIN_SUPPORTS)}
              sx={{
                textTransform: "none",
                borderRadius: 2,
                px: 3,
                py: 1.2,
                fontWeight: 600,
                transition: "transform 0.2s ease",
                "&:hover": { transform: "translateY(-1px)" },
                "&:active": { transform: "translateY(0) scale(0.98)" },
              }}
            >
              Vazgeç
            </Button>
            <Button
              type="submit"
              variant="contained"
              disabled={saving}
              sx={{
                textTransform: "none",
                borderRadius: 2,
                fontWeight: 700,
                px: 4,
                py: 1.2,
                background: buttonGradient,
                boxShadow: buttonShadow,
                transition:
                  "transform 0.2s ease, box-shadow 0.2s ease, background 0.2s ease",
                "&:hover": {
                  background: buttonGradientHover,
                  transform: "translateY(-1px)",
                },
                "&:active": { transform: "translateY(0) scale(0.98)" },
                "&:disabled": { background: "#c7c7c7" },
              }}
            >
              {saving ? (
                <CircularProgress size={20} sx={{ color: "#fff" }} />
              ) : (
                "Kaydet"
              )}
            </Button>
          </Box>
        </Paper>
      </Box>

      <Snackbar
        open={snack.open}
        autoHideDuration={2500}
        onClose={() => setSnack({ open: false, msg: "" })}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          severity="success"
          onClose={() => setSnack({ open: false, msg: "" })}
          sx={{ borderRadius: 2 }}
        >
          {snack.msg}
        </Alert>
      </Snackbar>
    </Box>
  );
}
